export const COOKIES_ACCEPT_NAME = 'sfb_accept_cookie';

// NODE_ENV=development is set by webpack
export const isDevServer = () => process.env.NODE_ENV && process.env.NODE_ENV === 'development';

export const getApiUrl = () => (isDevServer() ? 'http://localhost:8080' : 'https://api.semenyuk.eu');



// WEBPACK FOOTER //
// ./src/utils.js